module.exports = __webpack_public_path__ + "ba7f252daf6ba678dc0bf91126f22602.pdf";